// Node Modules
import { RichText } from 'prismic-reactjs';

// Components
import Container from '@/components/global-components/Container';
import InformationCard from '@/components/global-components/information-card/InformationCard';
import StyledCard from '@/components/global-components/styled-card/StyledCard';
import InstitutionDetails from './institution-details/InstitutionDetails';
import InstitutionInformation from './institution-information/InstitutionInformation';
import InstitutionPartners from './institution-partners/InstitutionPartners';


// Themes
import theme from '@/themes/index';

const AlliancesBody = ({
  content: {
    title,
    subTitle,
    institution,
    institutionHighlights,
    institutionAdditionalInformation,
    universityPartners,
    unis,
  },
  isDesktop,
}) => {
  return (
    <>
      <section className='title-section'>
        <Container>
          <h3>{title}</h3>
          <RichText render={subTitle} />
        </Container>
      </section>
      <section className='institution-section'>
        <Container>
          <StyledCard
            content={institution}
            isDesktop={isDesktop}
            imageStyles={{
              maxWidth: isDesktop ? '45rem' : '100%',
              maxHeight: isDesktop ? '30rem' : '100%',
            }}>
            <InformationCard content={institution} showTitle={true}/>
          </StyledCard>
          <InstitutionDetails
            content={institution}
            institutionHighlights={institutionHighlights}
          />
        </Container>
      </section>
      <hr />
      <section className='institution-additional-information'>
        <Container>
          <InstitutionInformation content={institutionAdditionalInformation} />
        </Container>
      </section>
      <hr />
      <section className='partners-section'>
        <Container>
          <InstitutionPartners
            unis={unis}
            content={universityPartners}
            isDesktop={isDesktop}
          />
        </Container>
      </section>
      <style jsx>{`
        hr {
          width: 100%;
          max-width: 87.5rem;
          margin: 0 auto;
        }

        section.title-section {
          padding: 8rem 0 3rem;
          text-align: center;
        }

        section.institution-section,
        section.institution-additional-information,
        section.partners-section {
          padding: 1.5rem 0;
        }

        section.title-section h3 {
          padding-bottom: 1rem;
          text-align: center;
          font-family: ${theme.fontFamilies.montserratSemiBold};
        }

        section.title-section p {
          line-height: 1.3rem;
        }

        section.title-section h3,
        p {
          margin-block-start: 0;
          margin-block-end: 0;
          margin-inline-start: 0;
          margin-inline-end: 0;
        }

        section.title-section p {
          font-family: ${theme.fontFamilies.montserrat};
        }

        @media only screen and (min-width: ${theme.breakpoints.tabletMin}) {
          section.title-section p {
            font-size: 1.5rem;
          }
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          section.title-section {
            padding: 5rem 2rem;
            text-align: left;
          }

          section.title-section h3 {
            padding-bottom: 1rem;
          }

          section.title-section p {
            line-height: 2.25rem;
          }

          section.institution-section,
          section.institution-additional-information {
            padding: 5rem 2rem;
          }

          section.partners-section {
            padding: 5rem 2rem;
          }
        }
      `}</style>
      <style global jsx>{`
      
      section.institution-section p a {
        font-size: inherit;
        line-height: inherit;
        text-decoration: none;
        color: #00E065;
      }

      section.institution-section p a:hover {
        text-decoration: underline;
      }
      `}</style>
    </>
  );
};

export default AlliancesBody;
